import { buyAction } from "model/actions/utilities/_buy";
import { formatMessage, randomMessage } from "model/message";

const ACTION_TYPE = "BuyFood";
const BULK = 10;

// A lot is inspected as a lot: one roll against the whole purchase. So buying ten at a time costs
// a tenth of the clicks and carries a risk the singles do not, which is the reason to still buy
// one at a time when the purse is thin. A single never spoils — paying for one sack and carrying
// away nothing read as the shop stealing from you.
const SPOIL_CHANCE = 0.1;
const SPOIL_RATE = 0.1;

const messageText = ({ cost, gain }, count) => {
  const gainText = randomMessage([
    "food acquired. ",
    "food bought. ",
    "food secured. ",
    "provisions for the journey. ",
    "supplies gathered. ",
    "stockpile increased. ",
  ]);
  const conditionText = gain.food < count ? "some of it is spoiled." : "";
  return formatMessage(`${gainText}${conditionText}`, { cost, gain });
};

const gainFor = (count) => {
  const isSpoiled = Math.random() < SPOIL_CHANCE;
  return {
    food: isSpoiled ? Math.max(1, Math.floor(count * (1 - SPOIL_RATE))) : count,
  };
};

const config = {
  type: ACTION_TYPE,
  resource: "food",
  label: "Buy Food",
  gainFor,
  messageText,
};

const buyFood = buyAction({ ...config, hotkey: "F" });
const buyFoodBulk = buyAction({ ...config, step: BULK });

export { buyFoodBulk, buyFood as default };
